import CatalogNavigation from './CatalogNavigation';

export default CatalogNavigation;
